// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"ddabdeb8","33":"23d95965","245":"99c5902d","372":"6d6d8a3c","760":"4a278574","791":"723e947c","864":"336c7a1d"}[chunkId] + ".chunk.css";
};